/*
 *
 *  sagas
 *
 */

import { call, take, put, race, all } from "redux-saga/effects"

import {
  LOAD_RECORDS_META_DATA,
  LOAD_EMPLOYEE,
  LOAD_CONVERT_LIST,
  LOAD_LEAD_CONVERT_LIST,
} from "./constants"

import {
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,
  loadEmployee,
  loadEmployeeSuccess,
  loadEmployeeError,
  loadConvertedList,
  loadConvertedListSuccess,
  loadConvertedListError,
  loadLeadConvertedList,
  loadLeadConvertedListSuccess,
  loadLeadConvertedListError,
} from "./actions"

import {
  loadRecordsMetaData,
  loadEmployeeList,
  loadConvertedDetails,
  loadLeadConvertedDetails,
} from "./remotes"

//import {
//    selectRecords,
//   selectUpdateTimestamp
//} from './selectors'
// import { selectSession } from "../session/selectors"
// import { roleIds } from "../../helpers/tools"

// Employee filter Saga

function* loadEmployeeSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_EMPLOYEE),
    })

    const { explicitLoad } = load

    // const { id } = explicitLoad || {}
    yield put(loadEmployee(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadEmployeeList)

        if (result) {
          yield put(loadEmployeeSuccess(result.data))
        } else {
          yield put(loadEmployeeError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadEmployeeError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* loadConvertedDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_CONVERT_LIST),
    })

    const { explicitLoad } = load

    const { searchFilter, acquire } = explicitLoad || {}
    yield put(loadConvertedList(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadConvertedDetails, searchFilter, acquire)

        console.log(result, "result")

        if (result) {
          yield put(loadConvertedListSuccess(result.data))
          console.log(result.Data, "result")
        } else {
          yield put(loadConvertedListSuccess([]))
          yield put(loadConvertedListError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(loadConvertedListSuccess([]))
        yield put(
          loadConvertedListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* loadLeadConvertedDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_LEAD_CONVERT_LIST),
    })

    const { explicitLoad } = load

    const { searchFilter } = explicitLoad || {}
    yield put(loadLeadConvertedList(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadLeadConvertedDetails, searchFilter)

        console.log(result, "result")

        if (result) {
          yield put(loadLeadConvertedListSuccess(result.data))
          console.log(result.Data, "result")
        } else {
          yield put(loadLeadConvertedListSuccess([]))
          yield put(loadLeadConvertedListError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(loadLeadConvertedListSuccess([]))
        yield put(
          loadLeadConvertedListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* loadRecordsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_RECORDS_META_DATA),
    })

    try {
      const processStatus = yield call(
        loadRecordsMetaData,
        "process_status",
        "post"
      )

      let obsMetaData = {
        processStatusOptions:
          (processStatus &&
            processStatus.data &&
            processStatus.data.length > 0 &&
            processStatus.data
              .filter((_) => _.status === 1)
              .map((p) =>
                Object.assign(
                  {},
                  {
                    label: p.processStatus,
                    value: p.processStatusId,
                    colorCode: p.colorCode,
                  }
                )
              )) ||
          [],
      }

      yield put(loadRecordsMetaDataSuccess(obsMetaData))
    } catch (error) {
      yield put(
        loadRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      )
    }
  }
}

export default function* recordsSaga() {
  yield all([
    loadRecordsMetaDataSaga(),
    loadEmployeeSaga(),
    loadConvertedDetailsSaga(),
    loadLeadConvertedDetailsSaga(),
  ])
}
